var TITLE_HEIGHT = 18;

/**
 * Прокручивает попап к выбранному варианту так, чтобы последний был поностью видим
 * @param {Object} params парметры для вычисления скролла
 * @param {HTMLElement} params.containerElement - контейнер всех вариантов.
 * @param {HTMLElement} params.targetElement - выбранный вариант.
 * @param {HTMLElement} params.parentElement - родитель выбранного варианта.
 * @param {center} boolean - признак необходимостии центрирования.
 */

export var scrollTo = function scrollTo(params) {
  var containerElementClientHeight = params.containerElement.clientHeight;
  var containerElementScrollTop = params.containerElement.scrollTop;
  var parentElementOffsetTop = params.parentElement.offsetTop;
  var parentElementScrollHeight = params.parentElement.scrollHeight;
  var targetElementOffsetTop = params.targetElement.offsetTop;
  var targetElementScrollHeight = params.targetElement.scrollHeight;
  var containerBottom = containerElementScrollTop + containerElementClientHeight;
  var valueBottom = targetElementOffsetTop + targetElementScrollHeight + parentElementOffsetTop + parentElementScrollHeight;
  if (valueBottom > containerBottom) {
    params.containerElement.scrollTop = valueBottom - containerElementClientHeight;
  } else if (targetElementOffsetTop + parentElementOffsetTop < containerElementScrollTop) {
    params.containerElement.scrollTop = targetElementOffsetTop + parentElementOffsetTop - TITLE_HEIGHT;
  }
};